import React, { Fragment, ReactElement } from 'react';
import { ContentData } from 'model/ContentData';
import globalClasses from '../Layout.module.css';
import NoContentAvailable from './NoContentAvailable';
import _ from 'classnames';
import ContentSection from './ContentSection';
import { ContentSectionType } from 'model/enums';
import { FormattedMessage } from 'react-intl';
import ConfigurationService from 'services/ConfigurationService';

interface IProps {
    contentCards: ContentData[];
}

export default function ContentPage(props: IProps): ReactElement {
    const displaySections = (): ReactElement => {
        const viewedContent: ContentData[] = props.contentCards.filter((x) => x.lastViewedDate);
        const notViewedContent: ContentData[] = props.contentCards.filter((x) => !x.lastViewedDate);
        const configuration = ConfigurationService.retrieveSessionConfiguration();

        return (
            <Fragment>
                <ContentSection
                    contentCards={notViewedContent}
                    sectionType={ContentSectionType.NotViewed}
                    disablePrint={configuration.disablePrint}
                    disablePrintMobileOnly={configuration.disablePrintMobileOnly}
                ></ContentSection>
                {viewedContent.length > 0 ? displayDivider() : null}
                <ContentSection
                    contentCards={viewedContent}
                    sectionType={ContentSectionType.Viewed}
                    disablePrint={configuration.disablePrint}
                    disablePrintMobileOnly={configuration.disablePrintMobileOnly}
                ></ContentSection>
            </Fragment>
        );
    };

    const displayDivider = (): ReactElement => {
        return (
            <div
                data-qaid="divider"
                className={_(globalClasses.sectionDivider, globalClasses.typography_divider)}
            >
                <span>
                    <FormattedMessage id="contentPage.Viewed" defaultMessage="VIEWED" />
                </span>
            </div>
        );
    };

    return (
        <React.Fragment>
            {!props.contentCards || props.contentCards.length === 0 ? (
                <NoContentAvailable />
            ) : (
                displaySections()
            )}
        </React.Fragment>
    );
}
